import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCbInsights = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10952_282080)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9.99974 19.6206C4.68629 19.6206 0.378906 15.3132 0.378906 9.99974C0.378906 4.68629 4.68629 0.378906 9.99974 0.378906C15.3132 0.378906 19.6206 4.68629 19.6206 9.99974C19.6206 15.3132 15.3132 19.6206 9.99974 19.6206Z",
				stroke: "#565CDE",
				strokeWidth: .758342,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.9734 9.41464H12.25V5.79626H14.4587C14.8675 5.79726 15.2592 5.96019 15.5481 6.24938C15.837 6.53857 15.9995 6.93045 16 7.3392V9.41483L15.9734 9.41464Z",
				fill: "#565CDE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.4301 14.1775H12.2217V10.3193H15.9467V12.6344C15.9734 13.4856 15.2815 14.1775 14.428 14.1775H14.4301Z",
				fill: "#565CDE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.88462 10.3193V9.38801H11.5296V5.79626H5.51875C4.6675 5.79626 4 6.49001 4 7.33939V12.6625C4.00045 13.0717 4.16319 13.464 4.45252 13.7533C4.74185 14.0426 5.13414 14.2054 5.54331 14.2058H11.5562V10.3193H7.88462Z",
				fill: "#565CDE"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_10952_282080",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgCbInsights;
